import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ComboCausaEliminacion/editComboCausaEliminacion`, method: 'POST', body: values, token: token})
}
